import { getContractBasedDataSelector } from '@cp-shared-19/frontend-integration';
import { RootState } from '../../../../store/rootReducer';

export const VehicleDetailsDataSelector = getContractBasedDataSelector((state: RootState) => state.vehicleDetails);
